module.exports = __webpack_public_path__ + "static/media/23.9e9659aa.jpg";